module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/assets/templates/expo-887d82b4e95ad9c41975bcb541c831f2.png";